import { action, observable, runInAction } from 'mobx';
import partnerController from '../../partners/store/controller';
import {
  OfficeInterface,
  GetOfficesForServiceAndPartnerRequest,
  EditPriceListForServiceOfficeRequest,
} from '../api/priceListServiceOfficeApi';

export interface PriceListServiceOfficeStore {
  offices: OfficeInterface[],
  serviceAndPartnerRequest: GetOfficesForServiceAndPartnerRequest, // по данному запросу в offices получили данные
  // priceListId: string,
  error: any,
  // currentOffice: OfficeInterface,
}

export const priceListServiceOfficeStore: PriceListServiceOfficeStore = observable({
  offices: [],
  serviceAndPartnerRequest: null,
  // priceListId: null,
  error: null,
  // currentOffice: null,
} as PriceListServiceOfficeStore);

export const priceListServiceOfficeActions = {
  getPartnerOfficesForServiceAndPartner: async (request: GetOfficesForServiceAndPartnerRequest): Promise<void> => {
    priceListServiceOfficeActions.clearError();
    const response = await partnerController
      .getPartnerOfficesForServiceAndPartner(request.serviceId, request.partnerId, request.showDeleted);
    priceListServiceOfficeStore.serviceAndPartnerRequest = request;
    priceListServiceOfficeActions.handleError(response);
    runInAction(() => {
      priceListServiceOfficeStore.offices = response.data;
    });
  },

  updatePartnerOfficeService: async (request: EditPriceListForServiceOfficeRequest): Promise<void> => {
    priceListServiceOfficeActions.clearError();
    const response = await partnerController.updatePartnerOfficeService(request);
    priceListServiceOfficeActions.handleError(response);
    runInAction(() => {
      if (!response.errorData) {
        priceListServiceOfficeStore.offices = priceListServiceOfficeStore.offices
          .map((v) => (v.serviceOfficeId === response.data.id
            ? { ...v, priceListId: response.data.priceListId, priceListName: response.data.priceListName }
            : { ...v }));
      }
    });
  },

  handleError: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      priceListServiceOfficeStore.error = errorData;
      throw errorData;
    }
  }),

  clearOffices: action(() => {
    priceListServiceOfficeStore.offices = [];
    priceListServiceOfficeStore.serviceAndPartnerRequest = null;
  }),

  clearError: action(() => {
    priceListServiceOfficeStore.error = null;
  }),
};
